var map = {
	"./add-more-role.svg": 761,
	"./assign.svg": 671,
	"./back_arrow.svg": 762,
	"./cancel.svg": 763,
	"./card_download.svg": 764,
	"./card_edit.svg": 765,
	"./card_refresh.svg": 766,
	"./cards.svg": 445,
	"./close-popup.svg": 767,
	"./collapse.svg": 446,
	"./contact-hotline.svg": 447,
	"./dd_contact hotline.svg": 768,
	"./dd_diagnostic_info.svg": 769,
	"./dd_file_management.svg": 770,
	"./dd_inventory_information.svg": 771,
	"./dd_my_contract.svg": 772,
	"./dd_peripheral_devices.svg": 773,
	"./dd_process_information.svg": 774,
	"./dd_system_configuration.svg": 775,
	"./dd_water_parameters.svg": 776,
	"./device-button.svg": 656,
	"./deviceCertificate.svg": 777,
	"./deviceSoftware.svg": 448,
	"./devices.svg": 778,
	"./download.svg": 659,
	"./exclamatory.svg": 779,
	"./file-doc.svg": 780,
	"./file-docx.svg": 781,
	"./file-pdf.svg": 782,
	"./file-ppt.svg": 783,
	"./file-pptx.svg": 784,
	"./file-text.svg": 785,
	"./file-xls.svg": 786,
	"./file-xlsx.svg": 787,
	"./file.svg": 788,
	"./fileManagement.svg": 449,
	"./file_csv.svg": 789,
	"./file_jpg.svg": 790,
	"./file_pdf.svg": 791,
	"./filter-sm.svg": 792,
	"./home.svg": 793,
	"./loading.svg": 672,
	"./logo_merck_loader.svg": 794,
	"./minus.svg": 795,
	"./notification status.svg": 796,
	"./notification-preferences.svg": 797,
	"./notvalidated.svg": 673,
	"./personal-details.svg": 798,
	"./quality rep.svg": 799,
	"./question-mark.svg": 800,
	"./refresh-circle.svg": 801,
	"./remote access.svg": 802,
	"./remote control.svg": 803,
	"./service_contract_add.svg": 804,
	"./service_contract_edit.svg": 805,
	"./service_contract_refresh.svg": 806,
	"./settings.svg": 807,
	"./sw-accepted-icon.svg": 660,
	"./sw-installation-failed.svg": 674,
	"./sw-installing.svg": 675,
	"./sw-not-authorized.svg": 676,
	"./sw-pending.svg": 668,
	"./sw-ready-to-install.svg": 677,
	"./sw-recall.svg": 669,
	"./sw-rejected.svg": 657,
	"./sw-release-acceptance.svg": 678,
	"./sw-release-fail.svg": 679,
	"./sw-release-installed.svg": 808,
	"./sw-update-available.svg": 680,
	"./sw-update-diabled.svg": 681,
	"./upto-date.svg": 809,
	"./user-preferences.svg": 810,
	"./userManagement.svg": 450,
	"./validated.svg": 682,
	"./waiting.svg": 811
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 500;